import { Pipe, PipeTransform } from '@angular/core';

import { DatesService } from '../services/dates.service';

@Pipe({
  name: 'dateByTimeZone',
  standalone: false,
})
export class DateByTimeZonePipe implements PipeTransform {
  constructor(private datesService: DatesService) {}
  transform(date: Date, format: string): string {
    return this.datesService.setDateByDealerSetting(date, format);
  }
}
